import { G300, R100 } from '@atlaskit/theme/colors';
import React from 'react';
import AbbreviatedNumberTooltip from "../Common/AbbreviatedNumberTooltip";
import { calculateRate, formatChartData, getElements } from "../PartnerReports.utils";
import { reportNameToTableHeaderMap } from "./CloudChurnOrRenewals.types";
export const calculateTotalCount = (elements = []) => elements.reduce((total, current) => current.count + total, 0);
export const getCloudReport = (reportName, apiResponse) => {
  const reportHeader = reportNameToTableHeaderMap[reportName];
  let total;
  let actual;
  let rate;

  if (apiResponse) {
    const totalSeries = apiResponse.series.find(item => item.name === reportHeader.total);
    total = (totalSeries === null || totalSeries === void 0 ? void 0 : totalSeries.uniqueTotal) || calculateTotalCount(totalSeries === null || totalSeries === void 0 ? void 0 : totalSeries.elements);
    const actualSeries = apiResponse.series.find(item => item.name === reportHeader.actual);
    actual = (actualSeries === null || actualSeries === void 0 ? void 0 : actualSeries.uniqueTotal) || calculateTotalCount(actualSeries === null || actualSeries === void 0 ? void 0 : actualSeries.elements);
    rate = calculateRate(total, actual);
  }

  return {
    total,
    actual,
    rate
  };
};
export const getCloudChurnOrRenewalTableData = (apiResponse, reportName) => apiResponse.addons.map(response => {
  const annualReport = getCloudReport(reportName, response.datasets.find(item => item.name === 'Annual'));
  const monthlyReport = getCloudReport(reportName, response.datasets.find(item => item.name === 'Monthly'));
  return {
    appKey: response.addonKey,
    appName: response.name,
    monthly: monthlyReport,
    annual: annualReport
  };
});
export const lineChartDetails = [{
  color: G300,
  dataKey: 'MonthlyRate',
  legend: 'Monthly rate'
}, {
  color: R100,
  dataKey: 'AnnualRate',
  legend: 'Annual rate'
}];

const getCountFromElements = element => element ? element.count : 0;

export const getChartData = (apiResponse, reportName) => {
  const reportHeader = reportNameToTableHeaderMap[reportName];
  const lineChartData = apiResponse.total.datasets.map(dataset => dataset.series[0].elements.map((element, index) => {
    const total = getCountFromElements(getElements(dataset.series, reportHeader.total)[index]);
    const actual = getCountFromElements(getElements(dataset.series, reportHeader.actual)[index]);
    const rate = calculateRate(total, actual);
    return {
      ["".concat(dataset.name, "Total")]: total,
      ["".concat(dataset.name, "Actual")]: actual,
      ["".concat(dataset.name, "Rate")]: rate,
      xLabel: element.date
    };
  }));
  return formatChartData(lineChartData);
};

const getValueFromPayload = (item, term, type) => {
  const value = item.payload[term + type];
  return typeof value === 'number' ? value : 0;
};

export const getChartTooltipPairs = payload => payload.map(item => {
  const term = item.dataKey.split('Rate')[0];
  const rate = getValueFromPayload(item, term, 'Rate');
  const actual = getValueFromPayload(item, term, 'Actual');
  const total = getValueFromPayload(item, term, 'Total');
  return {
    color: item.color,
    label: item.name,
    value: "".concat(rate, "% (").concat(actual, " / ").concat(total, ")")
  };
});
export const getColumns = (monthlyReport, reportName) => {
  const headerConfig = reportNameToTableHeaderMap[reportName];
  return [{
    key: headerConfig.total,
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: monthlyReport.total
    })
  }, {
    key: headerConfig.actual,
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: monthlyReport.actual
    })
  }, {
    key: headerConfig.rate,
    content: monthlyReport.rate ? "".concat(String(monthlyReport.rate), "%") : '--'
  }];
};
export const getReportColumnsForSeries = (datasets, reportName) => {
  const monthlyReport = getCloudReport(reportName, datasets.find(item => item.name === 'Monthly'));
  const annualReport = getCloudReport(reportName, datasets.find(item => item.name === 'Annual'));
  const monthlyColumns = getColumns(monthlyReport, reportName);
  const annualColumns = getColumns(annualReport, reportName);
  return [...monthlyColumns, ...annualColumns];
};